import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { MatPaginator, MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material';
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';
import { Filtro } from 'src/app/models/filtro';
import { CarregandoService } from 'src/app/services/carregando.service';
import { GlobalService } from 'src/app/services/global.service';
import { NotificacaoService } from 'src/app/services/notificacao.service';
import { ProdutoService } from 'src/app/services/produto.service';
import { UtilitarioService } from 'src/app/services/utilitario.service';

@Component({
  selector: 'app-importar-produtos-modal',
  templateUrl: './importar-produtos-modal.component.html',
  styleUrls: ['./importar-produtos-modal.component.scss']
})
export class ImportarProdutosModalComponent implements OnInit {

  carregando = true;
  campoOrdenacao = 'nome';
  ordenarDesc = false;

  paginacao = { tamanhoMaximo: 5, total: 0, paginaAtual: 1 };
  listaDeItensPorPagina = [];
  itensPorPagina = 10;
  filtroNome: Filtro = { Propriedade: 'descricao', Valor: '' };
  filtros: Filtro[] = [this.filtroNome];
  public config: PerfectScrollbarConfigInterface = {};

  kits = false;
  importarProdutos: boolean = false;

  tipoDeImportacao = [{ id: 0, descricao: 'Importar Kits' }, { id: 1, descricao: 'Importar Produtos' }, { id: 2, descricao: 'Atualizar Produtos' }, { id: 3, descricao: 'Importar Produtos' }];
  tipoImportacao = 0;
  titulo: string = 'Importar Kits';

  selectedFile: File;


  @ViewChild('paginator', { static: false }) paginator: MatPaginator;

  constructor(public dialogRef: MatDialogRef<ImportarProdutosModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private notificacaoService: NotificacaoService, private carregandoService: CarregandoService, private produtoService: ProdutoService,
    private utilitarioService: UtilitarioService, private globalService: GlobalService, public dialog: MatDialog) {
    if (data !== null && data !== undefined) {
      this.kits = data.kits;
      this.importarProdutos = data.produtos;
      this.tipoImportacao = data.tipoImportacao;
    }
  }

  ngOnInit() {
    this.titulo = this.tipoDeImportacao.find(p => p.id == this.tipoImportacao).descricao;
  }

  importar(): void {
    const dados = new FormData();
    dados.append('arquivo', this.selectedFile);

    this.carregandoService.mostra('importar');

    const onSuccess = (mensagem: string) => {
      this.carregandoService.esconde('importar');
      this.notificacaoService.sucesso(mensagem);
      this.dialogRef.close(true);
    };

    const onError = (erro: any) => {
      this.carregandoService.esconde('importar');
      this.notificacaoService.erro(erro);
    };

    if (this.tipoImportacao === 0) {
      this.produtoService.importar(dados, this.kits)
        .subscribe(
          () => onSuccess('Kits  importados com sucesso!!!'),
          onError
        );
    } else if (this.tipoImportacao === 1) {
      this.produtoService.importarProdutos(dados)
        .subscribe(
          () => onSuccess('Produtos importados com sucesso!!!'),
          onError
        );
      return;
    } else if (this.tipoImportacao === 2) {
      this.produtoService.atualizarProdutos(dados)
        .subscribe(
          () => onSuccess('Produtos atualizados com sucesso!!!'),
          onError
        );
    } else {
      this.produtoService.importar(dados, false)
        .subscribe(
          () => onSuccess('Produtos importados com sucesso!!!'),
          onError
        );
    }
  }

  fechar() {
    this.dialogRef.close();
  }

  onFileChanged(event) {
    this.selectedFile = event.target.files[0];
  }

  excluirArquivo() {
    this.selectedFile = undefined;
  }
}
